
import { useEffect, useState } from 'react';

interface ConfettiPiece {
  id: number;
  x: number;
  y: number;
  rotation: number;
  color: string;
  size: number;
  speedX: number;
  speedY: number;
  rotationSpeed: number;
  shape: 'square' | 'circle' | 'strip';
}

interface ConfettiProps {
  show: boolean;
  duration?: number;
}

export default function Confetti({ show, duration = 3000 }: ConfettiProps) {
  const [pieces, setPieces] = useState<ConfettiPiece[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  const colors = [
    '#F19953', '#e88a3f', '#d97b2b', '#FFD700', '#FF6B6B',
    '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD'
  ];

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      const newPieces: ConfettiPiece[] = [];
      
      for (let i = 0; i < 150; i++) {
        const shapes: ('square' | 'circle' | 'strip')[] = ['square', 'circle', 'strip'];
        newPieces.push({
          id: i,
          x: Math.random() * 100,
          y: -10 - Math.random() * 20,
          rotation: Math.random() * 360,
          color: colors[Math.floor(Math.random() * colors.length)],
          size: 6 + Math.random() * 8,
          speedX: (Math.random() - 0.5) * 4,
          speedY: 2 + Math.random() * 4,
          rotationSpeed: (Math.random() - 0.5) * 15,
          shape: shapes[Math.floor(Math.random() * shapes.length)]
        });
      }
      
      setPieces(newPieces);

      const timer = setTimeout(() => {
        setIsVisible(false);
        setPieces([]);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [show, duration]);

  if (!isVisible || pieces.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {pieces.map((piece) => (
        <div
          key={piece.id}
          className="absolute animate-confetti-fall"
          style={{
            left: `${piece.x}%`,
            top: `${piece.y}%`,
            transform: `rotate(${piece.rotation}deg)`,
            animationDuration: `${2 + Math.random() * 2}s`,
            animationDelay: `${Math.random() * 0.5}s`,
            '--speed-x': piece.speedX,
            '--speed-y': piece.speedY,
            '--rotation-speed': piece.rotationSpeed,
          } as React.CSSProperties}
        >
          {piece.shape === 'square' && (
            <div
              className="rounded-sm"
              style={{
                width: piece.size,
                height: piece.size,
                backgroundColor: piece.color,
              }}
            />
          )}
          {piece.shape === 'circle' && (
            <div
              className="rounded-full"
              style={{
                width: piece.size,
                height: piece.size,
                backgroundColor: piece.color,
              }}
            />
          )}
          {piece.shape === 'strip' && (
            <div
              className="rounded-full"
              style={{
                width: piece.size * 0.4,
                height: piece.size * 1.5,
                backgroundColor: piece.color,
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
